// extracted by mini-css-extract-plugin
module.exports = {"appointmentSuccessModalRoot":"index-appointmentSuccessModalRoot-CgfFI"};